export enum Anchors {
	Subscribe = 'subscribe',
}
